import React, { useEffect } from "react";
import "./manualinterno.css";

const Manualinterno = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container manualinterno-container">
      <div className="row">
        <div className="col_12">
          <div className="manualinterno_title">
            <h1>Manual Interno</h1>
          </div>
        </div>
      </div>

      <hr className="hr-gob" />
      <div>
        <iframe
          src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Interes/Manualinterno.pdf"
          height="1500"
          width="1110"
        ></iframe>
      </div>
    </div>
  );
};

export default Manualinterno;
